<script lang="ts">
	import { format } from 'svelte-i18n';
	import { ButtonV2, Modal, Text } from '@Shelly/shelly-design-system';
	import MonthlyReports from 'src/components/Consumption/MonthlyReports.svelte';

	let showModal = false;
</script>

<div class="d-flex gap-s justify-content-between align-items-center">
	<div>
		<Text styleType="body-medium" class="mb-xs">
			{$format('tab_energy_item_monthly_reports', { default: 'Monthly reports' })}
		</Text>
		<Text styleType="body-small" class="text-color-muted">
			{$format('settings_monthly_reports_description', {
				default: 'View monthly energy consumption reports for this home.',
			})}
		</Text>
	</div>

	<ButtonV2 size="m" variant="secondary" on:click={() => (showModal = true)}>
		{$format('button_open', { default: 'Open' })}
	</ButtonV2>
</div>

{#if showModal}
	<Modal
		{showModal}
		title={$format('tab_energy_item_monthly_reports', { default: 'Monthly reports' })}
		on:close={() => (showModal = false)}
	>
		<svelte:fragment slot="content">
			<MonthlyReports />
		</svelte:fragment>

		<div slot="footer" class="d-flex justify-content-end">
			<ButtonV2 variant="secondary" size="m" on:click={() => (showModal = false)}>
				{$format('button_close', { default: 'Close' })}
			</ButtonV2>
		</div>
	</Modal>
{/if}
